// reviewWrite(리뷰 작성) 페이지 온보딩 투어
// 상품을 골라 리뷰를 직접 작성하는 페이지 — 검색/필터 → 상품목록 → 리뷰현황 → 작성버튼 안내.
import { buildSteps } from '../tourStep';

export function buildReviewWriteSteps(ctx, tour) {
  const hasRow = !!document.querySelector('.rw-write-btn');

  return buildSteps([
    {
      id: 'welcome',
      emoji: '✏️',
      title: '리뷰 작성에 오신 걸 환영해요!',
      text: '여기서 상품을 골라 리뷰를 직접 작성할 수 있어요. 주요 흐름을 함께 둘러볼게요 :)',
      attachTo: null,
    },
    {
      id: 'filter',
      emoji: '🔍',
      title: '상품 찾기',
      text: '카테고리나 상품명·번호로 리뷰를 작성할 상품을 빠르게 찾으세요.',
      attachTo: { element: '.rw-filter-bar', on: 'bottom' },
    },
    {
      id: 'table',
      emoji: '📋',
      title: '상품 목록',
      text: '검색된 상품 목록이에요. 각 상품의 등록된 리뷰 수와 평점을 한눈에 볼 수 있어요.',
      attachTo: { element: '.rw-product-table-card', on: 'top' },
    },
    hasRow && {
      id: 'stats',
      emoji: '⭐',
      title: '리뷰 현황',
      text: '상품마다 현재 등록된 <b>리뷰 수</b>와 <b>평균 평점</b>이 표시돼요.',
      attachTo: { element: '.rw-review-stats', on: 'left' },
      beforeShow: '.rw-review-stats',
    },
    hasRow && {
      id: 'write',
      emoji: '🖊️',
      title: '리뷰 작성하기',
      text: '<b>작성</b> 버튼을 누르면 해당 상품에 리뷰를 직접 작성할 수 있어요.',
      attachTo: { element: '.rw-write-btn', on: 'left' },
      beforeShow: '.rw-write-btn',
    },
    {
      id: 'done',
      emoji: '🎉',
      title: '준비 끝!',
      text: '이제 자유롭게 작성해보세요. 다시 보고 싶으면 제목 옆 <b>?</b> 버튼을 누르면 돼요.',
      attachTo: null,
    },
  ], tour);
}

export default buildReviewWriteSteps;
